import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=627baefb&"
import script from "./MultipleChoice.vue?vue&type=script&lang=js&"
export * from "./MultipleChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627baefb')) {
      api.createRecord('627baefb', component.options)
    } else {
      api.reload('627baefb', component.options)
    }
    module.hot.accept("./MultipleChoice.vue?vue&type=template&id=627baefb&", function () {
      api.rerender('627baefb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-renderer/exam/Question/MultipleChoice.vue"
export default component.exports